import styled, { css } from "styled-components";
import React, { useCallback } from "react";
import Icon from "components/common/Icon";
const StyledSortIcon = styled.button(
  ({ theme, $disabled }) => css`
    border: 0;
    background: transparent;
    padding: 5px;
    cursor: ${$disabled ? "default" : "pointer"};
    position: relative;
    color: ${theme.colors.gray[70]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;

    &.active {
      color: ${theme.colors.gray[20]};
    }
  `
);
const Bulb = styled.span(
  ({ theme }) => css`
    position: absolute;
    top: 0;
    right: 0;
    font-size: ${theme.fonts.size.small};
    font-weight: 600;
  `
);
const SortIcon = ({
  activeDirection,
  onChange = void 0,
  title = "Sort",
  order = void 0,
  ascId = "Ascending",
  descId = "Descending",
  className = ""
}) => {
  const handleSortChange = useCallback(() => onChange(activeDirection), [activeDirection, onChange]);
  const isAscSort = activeDirection === ascId && activeDirection !== descId;
  const sortActive = !!activeDirection;
  const disabled = typeof onChange !== "function";
  if (disabled && !sortActive) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StyledSortIcon,
    {
      className: `${className} ${sortActive ? "active" : ""}`,
      title,
      type: "button",
      "aria-label": title,
      onClick: handleSortChange,
      $disabled: disabled
    },
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        size: "xs",
        name: isAscSort ? "arrow_upward" : "arrow_downward",
        "data-testid": "sort-icon-svg",
        className: `sort-icon-${isAscSort ? "asc" : "desc"}`
      }
    ),
    order && /* @__PURE__ */ React.createElement(Bulb, null, order)
  );
};
export default SortIcon;
